import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { DatePipe } from '@angular/common';
import { ExcelService } from 'src/app/service/excel.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import * as _moment from 'moment';

export interface StandardElement {
  name: string;
  dueAmount: string;
}

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-expense-list',
  templateUrl: './expense-list.component.html',
  styleUrls: ['./expense-list.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class ExpenseListComponent implements OnInit {
  displayedColumns: string[] = ['expenseType','purpose','date','amount'];
  dataSource:MatTableDataSource<any>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  tblLoading=false;
  itemTotal=0;
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  selectFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  startDate='';
  endDate='';
  srNo=0;
  totalExpenses=0;
  search='';

  constructor(private api:ApiService,private route:ActivatedRoute,private formBuilder:FormBuilder,private datePipe:DatePipe,private excelService:ExcelService) { 
    this.selectFormGroup=this.formBuilder.group({
      startDate:[''],
      endDate:['']
    });
  }

  ngOnInit() {
    this.route.data.subscribe(data=>{
      this.itemTotal=parseInt(data.expenseList[0].total);
      this.dataSource.data=data.expenseList[0].data;
      this.totalExpenses=data.expenseList[0].totalAmount;
    },(error)=>{

    });
  }

  counter(i)
  {
    let num=i+1;
    return this.srNo+num;
  }

  refreshTable(start,pageSize)
  {
    if(this.startDate!="" && this.endDate!="")
    {
      this.api.get("expenseList?orderBy=date_desc,id_desc&start="+start+"&length="+pageSize+"&startDate="+this.startDate+"&endDate="+this.endDate).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        this.dataSource.data=data.data;
        this.totalExpenses=data.totalAmount;
      },(error)=>{

      });
    }
    else
    {
      this.api.get("expenseList?orderBy=date_desc,id_desc&start="+start+"&length="+pageSize).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        this.dataSource.data=data.data;
        this.totalExpenses=data.totalAmount;
       
      },(error)=>{

      });
    }
    
  }

  reset()
  {
    window.location.reload();
  }

  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  fetch(form)
  {
    this.startDate=(form.value.startDate!="")?this.datePipe.transform(form.value.startDate,"dd/MM/yyyy"):'';
    this.endDate=(form.value.endDate!="")?this.datePipe.transform(form.value.endDate,"dd/MM/yyyy"):'';
    this.refreshTable(0,10);
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    this.srNo=start;
    let postData={start:start,length:event.pageSize};
    this.api.get("expenseList?orderBy=date_desc,id_desc&start="+start+"&length="+event.pageSize).subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
    },(error)=>{

    });
  }

  exportAsXLSX():void {
    if(this.startDate!="" && this.endDate!="")
    {
      this.api.get("expenseList?&export=excel&startDate="+this.startDate+"&endDate="+this.endDate).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        data.data.push({"Date":"Total","Amount":data.totalAmount});
        this.excelService.exportAsExcelFile(data.data, 'sample');
        
      },(error)=>{
  
      });
    }
    else
    {
      let url='';
      if(this.search.length>1)
      {
        url="expenseList?&export=excel&name="+this.search;
      }
      else
      {
        url="expenseList?&export=excel";
      }
      this.api.get(url).subscribe(data=>{
        this.itemTotal=parseInt(data.total);
        data.data.push({"Date":"Total","Amount":data.totalAmount});
        this.excelService.exportAsExcelFile(data.data, 'sample');
      },(error)=>{
  
      });
    }
    
    
 }

 searchname(e)
 {
   let url='';
   if(e.target.value.length>1)
   {
     this.search=e.target.value;
    url="expenseList?&orderBy=date_desc&start=0&length=10&name="+e.target.value;
   }
   else if(e.target.value.length==0)
   {
    this.search='';
     url="expenseList?&orderBy=date_desc&start=0&length=10&";
   }

   this.api.get(url).subscribe(data=>{
    this.itemTotal=parseInt(data.total);
    this.dataSource.data=data.data;
    this.totalExpenses=data.totalAmount;
  },(error)=>{

  });
    
 }

}
